export default __webpack_public_path__ + "static/media/13185-paperd.fe98e066.pdf";